var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingAtlasFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#training-atlas-filled_svg__clip0_258_3312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.02 4.3L21.283-.038l.4 1.96L.42 6.26.02 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8H2a1 1 0 00-1 1v14a1 1 0 001 1h20a1 1 0 001-1V9a1 1 0 00-1-1zm-4.8 7.2h-.8v-2.4a.8.8 0 00-.8-.8h-.8a.8.8 0 00-.8.8v2.4h-4v-2.4a.8.8 0 00-.8-.8h-.8a.8.8 0 00-.8.8v2.4h-.8a.8.8 0 100 1.6h.8v2.4a.8.8 0 00.8.8h.8a.8.8 0 00.8-.8v-2.4h4v2.4a.8.8 0 00.8.8h.8a.8.8 0 00.8-.8v-2.4h.8a.8.8 0 100-1.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "training-atlas-filled_svg__clip0_258_3312"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTrainingAtlasFilled;